import DieselLocoSection from './DieselLocoSection'
import Locomotive from './Locomotive'

export default class DieselLocomotive extends Locomotive {
    locoSections = Array<DieselLocoSection>()
}
